export var FeatureFlagEnum;
(function (FeatureFlagEnum) {
    // Tim added this on 02/23/23 expected to remove in ??
    FeatureFlagEnum["RELEASE_GATE_CHARACTER_SHEET_TOUR"] = "release-gate-character-sheet-tour";
    // Julie added this on 10/20/26 - Builder starts at Class and Home moves behind a settings cog
    FeatureFlagEnum["RELEASE_GATE_BUILDER_FLOW_EXPERIMENT"] = "release-gate.builder-flow-experiment";
})(FeatureFlagEnum || (FeatureFlagEnum = {}));
export const FEATURE_FLAG_LIST = [
    FeatureFlagEnum.RELEASE_GATE_CHARACTER_SHEET_TOUR,
    FeatureFlagEnum.RELEASE_GATE_BUILDER_FLOW_EXPERIMENT,
];
export const DEFAULT_FEATURE_FLAG_INFO = {
    [FeatureFlagEnum.RELEASE_GATE_CHARACTER_SHEET_TOUR]: false,
    [FeatureFlagEnum.RELEASE_GATE_BUILDER_FLOW_EXPERIMENT]: false,
};
